import {Component, OnInit} from '@angular/core';
import {MultiSelectModule} from 'primeng/multiselect';
import {NgForOf, NgIf} from '@angular/common';
import {PaginatorModule} from 'primeng/paginator';
import {HttpClient} from '@angular/common/http';
import {RoleService} from '../../services/role.service';
import {DocumentService} from '../../services/document.service';
import {UtilsService} from '../../appSharedModule/services/utils.service';
import {MessageService, SelectItem} from 'primeng/api';
import {AuthenticationService} from '../../authenticationModule/services/authentication.service';
import {CheckboxModule} from 'primeng/checkbox';
import {environment} from '../../../environments/environment';
import * as _ from 'lodash';
import {InputTextModule} from 'primeng/inputtext';
import {EditorModule} from 'primeng/editor';
import {EmergencyAnnouncement} from '../../models/emergency-announcement';
import {AnnouncementService} from '../../services/announcement.service';
import {DialogModule} from 'primeng/dialog';
import {RadioButtonModule} from 'primeng/radiobutton';
import {FormsModule} from '@angular/forms';
import {firstValueFrom} from 'rxjs';

@Component({
  selector: 'app-send-emergency-announcement',
  standalone: true,
  imports: [MultiSelectModule, NgIf, PaginatorModule, CheckboxModule, NgForOf, InputTextModule, EditorModule, DialogModule, RadioButtonModule, FormsModule],
  templateUrl: './send-emergency-announcement.component.html',
  styleUrl: './send-emergency-announcement.component.scss'
})

export class SendEmergencyAnnouncementComponent implements OnInit {
  companiesItems: SelectItem[];
  groupsItems: SelectItem[] = [];
  emergencyAnnouncement: EmergencyAnnouncement = new EmergencyAnnouncement();
  selectedGroups: string[] = [];
  listClients = [];
  error: boolean;
  errorMessage: string;
  loading: boolean;
  title: string;
  display: boolean;
  messagePreview: string;
  noSelectedUser = false;
  success: boolean;
  successMessage: string;
  srcImg: string;
  bannersOptions: SelectItem[] = [];
  footer: any;

  constructor(private http: HttpClient,
              private roleService: RoleService,
              private announcementService: AnnouncementService,
              private utilsService: UtilsService,
              private documentService: DocumentService,
              private messageService: MessageService,
              private authenticationService: AuthenticationService) {
  }

  ngOnInit() {
    this.initFields();
    this.getClients();
    this.error = false;
    this.errorMessage = '';
    this.bannersOptions = [
      {label: 'Based on client affiliation', value: 'clientAffiliation'},
      {label: 'McKay only', value: 'mckay'},
      {label: 'Quincy only', value: 'quincy'}
    ];
    this.getEmailFooter();

  }

  private getEmailFooter() {
    this.documentService.getEmailFooter().subscribe(
      res => {
        this.footer = res;
      }
    );
  }

  sendAnnouncement() {
    if ((this.emergencyAnnouncement.message?.length ?? 0) > 10000) {
      this.error = true;
      this.errorMessage = 'Make sure the email body is not longer than 10,000 characters.';
      return;
    }
    if (!this.emergencyAnnouncement.companiesUniqId?.length) {
      this.noSelectedUser = true;
      this.messageService.add({
        severity: 'error', summary: 'Error',
        detail: 'Please select at least one client to send the notification.', sticky: true, closable: true
      });
      return;
    }
    this.noSelectedUser = false;
    this.announcementService.sendNotificationToClients(this.emergencyAnnouncement).subscribe({
        next: () => {
          this.error = false;
          this.success = true;
          this.successMessage = 'Emergency announcement has been sent successfully.';
          this.initForm();
        }, error: error => {
          this.success = false;
          this.error = true;
          if (!error.error.message) {
            this.errorMessage = 'An error has been occurred while sending emergency announcement .';
          } else {
            this.errorMessage = error.error.message;
          }
        }
      });
  }

  previewEmail() {
    if (this.emergencyAnnouncement.banner === 'mckay') {
      this.srcImg = '../../../assets/images/logo-mckay.png';
    } else if (this.emergencyAnnouncement.banner === 'quincy') {
      this.srcImg = '../../../assets/images/logo-quincy.png';
    }
    this.title = 'Subject: ' + this.emergencyAnnouncement.subject;
    this.display = true;
    this.messagePreview = this.normalizeMustache(this.emergencyAnnouncement.message ?? '');
  }

  normalizeMustache(text: string): string {
    return text.replace(/\{\{([\s\S]*?)\}\}/g, (_full, inner: string) => {
      const edgeWs = /^(?:\s|\u00A0|&nbsp;)+|(?:\s|\u00A0|&nbsp;)+$/g;
      const trimmed = inner.replace(edgeWs, '');
      return `{{${trimmed}}}`;
    });
  }

  private initFields() {
    this.groupsItems = this.roleService.roles.map(role => {
      return {label: role.sfGuardGroupDescription, value: role.sfGuardGroupId, title: role.description};
    });
  }

  private getClients() {
    const companyUrl = environment.baseUrlWs + '/api/clients-dropdown';
    this.utilsService.cacheablePromise(() => firstValueFrom(this.http.get<any>(companyUrl)), 'companiesDropDown__' + this.authenticationService.userImpersonatedId, true)
      .then(response => {
        this.listClients = response['member'].filter(client => client.uniqid !== 'admin' && client.isActive !== false);
        this.refreshCompaniesItems();
        this.loading = false;
        this.utilsService.unlockUi();
      }, error => {
        this.error = true;
        this.errorMessage = error.error.message;
      });
  }

  private refreshCompaniesItems() {
    this.companiesItems = [];
    this.listClients.forEach(client => {
      this.companiesItems.push({
        label: client.name, value: client.uniqid
      });
    });
    this.companiesItems = _.sortBy(this.companiesItems, ['label']);
  }

  getFooter() {
    if (!this.footer) {
      return '';
    }
    if (this.emergencyAnnouncement.banner === 'quincy') {
      return this.footer['quincy'];
    }
    return this.footer['mckay'];
  }

  isSentDisabled() {
    return (!this.emergencyAnnouncement.companiesUniqId?.length || !this.emergencyAnnouncement.subject || !this.emergencyAnnouncement.message || !this.emergencyAnnouncement.selectedGroups?.length || !this.emergencyAnnouncement.banner);
  }

  setSelectedGroup() {
    this.emergencyAnnouncement.selectedGroups = this.selectedGroups;
  }

  protected initForm() {
    this.selectedGroups = [];
    this.emergencyAnnouncement = new EmergencyAnnouncement();
  }
}
